<template>
  <div class="d-flex flex-column" style="height: 500px;">
    <h3 class="m-0">Reenviar correo de factura a:</h3>
    <hr class="w-100 mt-2 mb-3" />
    <form @submit.prevent="addEmail()" class="d-flex align-items-center">
      <base-input
        v-model="address"
        placeholder="Agrega otro correo"
        inputClasses="input-group-alternative form-control-sm text-xs"
        class="flex-grow-1 m-0"
        type="email"
      />
      <base-button
        nativeType="submit"
        :disabled="!address"
        icon="fa fa-plus"
        size="sm"
        type="primary"
        class="flex-shrink-0 m-0 ml-3"
      >
      </base-button>
    </form>
    <hr class="w-100 my-3" />
    <div class="flex-grow-1 d-flex" style="min-height: 0; overflow-y: auto;">
      <div v-if="emails && emails.length" class="flex-grow-1">
        <div
          v-for="email in emails"
          :key="email"
          class="parent d-flex align-items-center justify-content-between py-1 px-3"
        >
          <p class="text-xs m-0 font-weight-normal">
            {{ email }}
          </p>
          <div
            @click="removeEmail(email)"
            class="remove flex-shrink-0 d-flex justify-content-center align-items-center rounded"
            style="height: 22px; width: 22px;"
          >
            <i class="fa fa-trash fa-xs text-red"></i>
          </div>
        </div>
      </div>
      <div v-else class="flex-grow-1 d-flex align-items-center justify-content-center">
        <EmptySection/>
      </div>
    </div>
    <hr class="w-100 my-3" />
    <div class="d-flex justify-content-end">
      <base-button type="muted" @click="$emit('close')">
        Cancelar
      </base-button>
      <base-button
        @click="sendEmail()"
        icon="fa fa-check"
        type="primary"
        :disabled="!emails || !emails.length"
      >
        Enviar
      </base-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getAuth } from "firebase/auth";
import EmptySection from "@/components/EmptySection.vue";

export default {
  name: "EmailsList",
  components: {
    EmptySection,
  },
  props: {
    contacts: {
      type: Array,
      required: true,
    },
    docNum: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      address: null,
      emails: [],
    };
  },
  methods: {
    addEmail() {
      this.emails.push(this.address);
      this.address = null;
    },
    removeEmail(email) {
      this.emails = this.emails.filter((x) => x !== email);
    },
    sendEmail() {
      const json = {
        DocNum: this.docNum,
        emails:
          process.env.NODE_ENV === "production" ? this.emails : [this.user.email],
      };
      console.log("JSON", json);

      axios
        .post(`api/fpt/resend/invoice`, json)
        .then((res) => {
          console.log("RES", res)
          if(res.data.msg){
            this.$swal({
              title: "Correo enviado",
              text: res.data.msg,
              icon: "success",
            }).then(() => {
              this.$emit("close");
            });
          } else {
            this.$swal({
              title: "Error",
              text: "No se pudo enviar el correo",
              icon: "error",
            });
            console.error("Error", res.data);
          }
        })
        .catch((error) => {
          console.error(error)
        });
    },
  },
  created() {
    this.user = getAuth().currentUser;
    this.emails = this.contacts
      .filter((contacto) => contacto.U_TS_EnvioCorreo === "SI")
      .map((contacto) => contacto.E_Mail)
      .filter((email) => email !== null);
  },
};
</script>

<style lang="scss" scoped>
.remove {
  cursor: pointer;
}
.remove:hover {
  background-color: #fee2e2;
}
.parent:hover {
  background-color: #f8f9fe;
}
</style>
